import { Form } from 'antd';
import React, { FunctionComponent, useState } from 'react';
import { ConsentCheckbox } from '../../styles/ConsentCheckbox';
import { FlowContentBody, QuestionWrapper } from '../../styles/Containers';
import { TextInput } from '../../styles/TextInput';
import { BodySM, HeroTitle } from '../../styles/Typography';
import { LayoutActions } from './LayoutActions';

/** Copy for the partner-insurer offer. `{{insurer}}` is replaced with the partner's short name. */
export type PartnerInsurerAccessLayoutConfig = {
  title: string;
  body: string[];
  inputLabel: string;
  inputPlaceholder: string;
  consentLabel: string;
  primaryButtonTitle: string;
  secondaryButtonTitle: string;
};

// No insurer format is validated yet; this only bounds what is stored and shared.
const MEMBER_ID_MAX_LENGTH = 16;

type Props = PartnerInsurerAccessLayoutConfig & {
  onUse: (memberId: string) => void;
  onContinueWithout: () => void;
};

export const PartnerInsurerAccessLayout: FunctionComponent<Props> = (props) => {
  const [memberId, setMemberId] = useState('');
  const [consent, setConsent] = useState(false);
  const trimmedMemberId = memberId.trim();
  const canUse = trimmedMemberId.length > 0 && consent;

  function onPrimaryPress(): void {
    if (canUse) props.onUse(trimmedMemberId);
  }

  return (
    <Form>
      <QuestionWrapper>
        <FlowContentBody>
          <HeroTitle data-test="surveyQuestion">{props.title}</HeroTitle>
          {props.body.map((line, index) => (
            <BodySM key={index}>{line}</BodySM>
          ))}
          <Form.Item>
            <TextInput
              type="text"
              autoComplete="off"
              maxLength={MEMBER_ID_MAX_LENGTH}
              value={memberId}
              placeholder={props.inputPlaceholder}
              aria-label={props.inputLabel}
              data-testid="partner-insurer-member-id"
              onChange={({ target: { value } }) => setMemberId(value)}
            />
          </Form.Item>
          <ConsentCheckbox
            checked={consent}
            onChange={setConsent}
            label={props.consentLabel}
            testId="partner-insurer-consent"
          />
        </FlowContentBody>
        <LayoutActions
          primaryButtonTitle={props.primaryButtonTitle}
          onPressPrimaryButton={onPrimaryPress}
          primaryButtonDisabled={!canUse}
          secondaryButtonTitle={props.secondaryButtonTitle}
          onPressSecondaryButton={props.onContinueWithout}
          secondaryButtonPlacement="below"
          secondaryButtonTestId="partner-insurer-continue-without"
        />
      </QuestionWrapper>
    </Form>
  );
};
